import { useContext, useEffect, useState } from "react"
import { AuthContext } from "context/AuthContext"
import { useQuery, useQueryClient } from "react-query"
import { getUsers } from "services/api/User"
import { Edit as EditIcon, Delete as DeleteIcon, AccountCircle as AccountCircleIcon, Add as AddIcon, Block as BlockIcon } from '@mui/icons-material'
import { Fab, IconButton, Paper, Tooltip } from "@mui/material"
import SectionIndexAdmin from "components/Loaders/SectionIndexAdmin"
import ToolBar from "components/ToolBar"
import { SnackbarGlobal } from "components/Snackbar"
import Add from "./Add"
import Remove from "./Remove"
import { getRoles } from "services/api/Role"
import { getBasicRealStateDevelopments } from "services/api/RealStateDevelopment"
import Edit from "./Edit"

export default function User() {
  const { setTitlePage } = useContext(AuthContext)
  const [openAction, setOpenAction] = useState(0) // 0: close, 1: add, 2: edit, 3: delete
  const [instanceSelected, setInstanceSelected] = useState({})
  const [notification, setNotification] = useState({ open: false, message: "", severity: "" })
  const [dataFilter, setDataFilter] = useState(null)
  const queryClient = useQueryClient()
  const { isLoading, isFetching, error, data } = useQuery(
    'usersList',
    getUsers,
    { refetchOnWindowFocus: false }
  )
  const { isLoading: iLRoles, isFetching: iFRoles, error: eRoles, data: dRoles } = useQuery(
    'rolesList',
    getRoles,
    { refetchOnWindowFocus: false }
  )
  const { isLoading: iLRSD, isFetching: iFRSD, error: eRSD, data: dRSD } = useQuery(
    'rsdList',
    getBasicRealStateDevelopments,
    { refetchOnWindowFocus: false }
  )

  useEffect(() => { 
    setTitlePage("Usuarios") 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (data !== undefined && data !== null && data !== "") setDataFilter(data.data)
  }, [data])

  const handleRefreshData = () => { queryClient.invalidateQueries('usersList') }

  const handleResetActions = () => setOpenAction(0)

  const handleWatchAction = (success, message, severity) => {
    setNotification({ open: true, message: message, severity: severity })
    if (success) { handleResetActions(); handleRefreshData() }
  }

  const handleSearch = (e) => {
    const dataFilter = data.data.filter(item => item.email.toLowerCase().includes(e.target.value.toLowerCase(), 0))
    setDataFilter(dataFilter)
  }

  const Actions = ({ item }) => (<>
    <IconButton onClick={() => { setInstanceSelected(item); setOpenAction(2) }}><EditIcon color="info" /></IconButton>
    <IconButton onClick={() => { setInstanceSelected(item); setOpenAction(3) }}><DeleteIcon color="error" /></IconButton>
  </>)

  if (isLoading || isFetching || iLRoles || iFRoles || iLRSD || iFRSD) return <SectionIndexAdmin />
  if (error || eRoles || eRSD) return <div>Ha ocurrido un error</div>

  return (<>
    <div className="toolbar_container"><ToolBar searchFunction={handleSearch} /></div>
    <div>
      {dataFilter !== null && dataFilter.length === 0 &&
        <Paper elevation={1} className="without-data-container">
          <p> No hay datos a mostrar </p>
          <p> Agrega tu primer registro dando click en el botón <Fab color="primary" size="small" disabled><AddIcon /></Fab> del lado derecho inferior</p>
        </Paper>}
      {(dataFilter !== null) && dataFilter.map((item, index) =>
        <Paper className="list_item_container" elevation={1} key={index}>
          <div className="list_item_data">
            <div> <AccountCircleIcon /> </div>
            <div>
              <div style={{ color: item.active ? "#000000" : "#a7a4a4" }}>
                <div style={{ display: "flex" }}>
                  <span style={{ marginRight: 8 }}>{item.name} | {item.email}</span> {!item.active ? <BlockIcon /> : null}
                </div>
              </div>
            </div>
          </div>
          <div className="list_item_actions"> <Actions item={item} /> </div>
        </Paper>
      )}
    </div>
    <span className="fab_add">
      <Tooltip title="Agregar"><Fab color="primary" onClick={() => setOpenAction(1)}><AddIcon /></Fab></Tooltip>
    </span>
    {((dRoles !== undefined && dRoles.data !== null && dRoles.data !== "") || (dRSD !== undefined && dRSD.data !== null && dRSD.data !== "")) && <>
      <Add open={openAction === 1} close={() => handleResetActions()} reportAction={handleWatchAction} roles={dRoles.data} rsd={dRSD.data} />
      <Edit open={openAction === 2} close={() => handleResetActions()} instance={instanceSelected} reportAction={handleWatchAction} roles={dRoles.data} rsd={dRSD.data} />
      <Remove open={openAction === 3} close={() => handleResetActions()} instance={instanceSelected} reportAction={handleWatchAction} />
    </>}
    <SnackbarGlobal vertical='bottom' horizontal='center' open={notification.open} close={() => setNotification({ open: false, message: "", severity: "" })} message={notification.message} severity={notification.severity} />
  </>)
}